import { render, staticRenderFns } from "./RightInsta.vue?vue&type=template&id=09fa1cb2&scoped=true&"
import script from "./RightInsta.vue?vue&type=script&lang=js&"
export * from "./RightInsta.vue?vue&type=script&lang=js&"
import style0 from "./RightInsta.vue?vue&type=style&index=0&id=09fa1cb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09fa1cb2",
  null
  
)

export default component.exports